/**
 * Handles sorting and adding products to the cart for B2B customers on the Quick Order Form page.
 * This script has been intentionally written with ECMAScript 5 syntax (2009) to ensure maximum code compatibility.
 * 
 * @author Juicyorange
 */
document.addEventListener("DOMContentLoaded", function() {
  // Variable declarations
  const addToCartButtons = document.querySelectorAll('.add-to-cart');
  const quickAddToCartButton = document.querySelector('.add-all-to-cart');
  const quantityInputAdjustmentEls = document.querySelectorAll('.product-form__qty-btn');
  const quantityInputs = document.querySelectorAll('.quantity-input');
  const allVariantSelectors = document.querySelectorAll('.js-product-variant-select');

  /**
   * Event listener for the click event on the add-to-cart buttons.
   * Sends a request to Shopify to add the selected item to the cart.
   * 
   * @param {HTMLButtonElement} button - The add to cart button for each product.
   * @param {Event} event - The click event.
   * @returns {Promise<void>} - A promise resolving with the fetch response.
   */
  addToCartButtons.forEach(function (button) {
    
    button.addEventListener('click', async function () {
      let quantityInput = button.closest('.quick-order-form--table-product-row').querySelector('.quantity-input');
      const variantSelector = button.closest('.quick-order-form--table-product-row').querySelector('.js-product-variant-select');
      const qtyAriaLive = button.closest('.quick-order-form--table-product-row').querySelector('.product-qty-arialive');

      if (variantSelector) {
        var variantId = variantSelector.querySelector('option[selected="selected"]').value; 
      }

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId ? variantId : button.value,
              quantity: quantityInput.value || 0,
            }],
          }),
        });
        const data = await response.json();
        let currentButtonText = button.innerHTML;
        button.innerHTML = data.status === 422 ? `${data.description}`: "Added to cart!";
        setTimeout(() => {
          button.innerHTML = currentButtonText;
          quantityInput.value = 0;
          quantityInput.setAttribute('value', quantityInput.value);
          button.disabled = true;
          qtyAriaLive.textContent = "Product quantity is zero";
        }, 2500);
      } catch (error) {
        console.error(`Issue sending product data to Shopify: ${error}`);
      }
    });
  });

  /**
   * Add to cart all products on page that have a quantity set to greater than zero.
   * 
   * @param {Event} event - The click event.
   * @returns {Promise<Void>} - A promise resolving with the fetch response.
   */
  quickAddToCartButton.addEventListener('click', async function () {
    let data = {
      items: [],
    };
    const selectedProducts = document.querySelectorAll('.quantity-input');
    
    selectedProducts.forEach(function (product) {
      if (parseInt(product.value) >= 1) {
        data.items.push({
          id: product.dataset.productId,
          quantity: parseInt(product.value)
        });
      }
    });
    
    try {
      console.log(data)
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      console.log(response);
      if (response.status === 200) {
        window.location.href = `${window.Shopify.routes.root}cart`;
      }
    } catch (error) {
      console.error(`Issue sending product data to Shopify: ${error}`);
    }
  });


  /**
   * Event listener on each product row that sets the quantity when the increase or decrease buttons are clicked.
   * 
   * @param {HTMLInputElement} input - The quantity adjustment input element.
   * @returns {Number} Adjusted quantity.
   */
  quantityInputAdjustmentEls.forEach(function (input) {
    const addToCartButton = input.closest('.quick-order-form--table-product-row').querySelector('.add-to-cart');
    const qtyInput = input.closest('.quick-order-form--table-product-row').querySelector('.quantity-input');
    const qtyAriaLive = input.closest('.quick-order-form--table-product-row').querySelector('.product-qty-arialive');
    const variantSelector = input.closest('.quick-order-form--table-product-row').querySelector('.js-product-variant-select');

    if (variantSelector) {
      variantSelector.addEventListener('change', function () {
        variantSelector.querySelectorAll('option').forEach((opt, index) => {
          if (index === variantSelector.selectedIndex) {
            qtyInput.dataset.productId = opt.value;
          }
        });
      });
    }

    input.addEventListener('click', function() {
      if (input.dataset.actionType == "minus") {
        if (parseInt(qtyInput.value) > 0) {
          qtyInput.value -= 1;
          qtyAriaLive.textContent = `${qtyInput.value} products.`;

          if (parseInt(qtyInput.value) === 0) {
            addToCartButton.disabled = true;
            qtyAriaLive.textContent = "Product quantity is zero."
          } 
        }
      } else {
        qtyInput.value = parseInt(qtyInput.value) + 1;
        qtyAriaLive.textContent = `${qtyInput.value} products.`;
        addToCartButton.disabled = false;
      }
    });
  })

  /**
   * Event listener on each product row that adjusts the add to cart button status
   * @param {HTMLInput}
   */
  quantityInputs.forEach(function (input) {
    input.addEventListener('change', function() {
      const addToCartButton = input.closest('.quick-order-form--table-product-row').querySelector('.add-to-cart');

        if (parseInt(input.value) === 0) {
          addToCartButton.disabled = true;
        } else {
          addToCartButton.disabled = false;
        }
    });
  });

  /**
    * Event listener for each variant selector that sets the selected atteribute
    * @param {NodeListOf<HTMLSelectElement>} allVariantSelectors - The collection of variant selector elements
    */
  if (allVariantSelectors) {
    allVariantSelectors.forEach(function (variantSelector) {
      variantSelector.addEventListener('change', function() {
        variantSelector.querySelectorAll('option').forEach((opt, index) => {
          if (index === variantSelector.selectedIndex) {
            opt.setAttribute('selected', 'selected');
          } else {
            opt.removeAttribute('selected');
          }
        });
      });
    });
  }  
});
